import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bid-description-wrapper"
}
const _hoisted_2 = ["innerHTML"]


import { useStore } from 'vuex';
import { computed } from 'vue';
import { RAW_ASSETS_STATUSES } from '@/constants/statuses';
import { Utils } from '@/utils';

// #interfaces
interface IProps {
  isDisabledForm: boolean;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewDescription',
  props: {
    isDisabledForm: { type: Boolean, default: false }
  },
  setup(__props: any) {



// #constants
const { getters, commit } = useStore();

// #computed
const getBidDescription = computed<string>(() => {
  return getters['getBidDescription'];
});

const getFormattedBidDescription = computed<string>(() => {
  return Utils.getFormattedComment(getBidDescription.value);
});

const auctionStatus = computed<string>(() => {
  const { status } = getters['getAsset'] ?? {};
  return status;
});
const isReadonlyInput = computed<boolean>(() => {
  const status = auctionStatus.value;

  return ![
    RAW_ASSETS_STATUSES.ACTIVE,
    RAW_ASSETS_STATUSES.PRE_AUCTION
  ].includes(status);
});

// #methods
const setBidDescription = (val: string) => {
  commit('setBidDescription', val);
};

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (isReadonlyInput.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "bid-description-wrapper__title" }, "Comments", -1)),
        _createElementVNode("div", {
          class: "bid-description-wrapper__text",
          innerHTML: getFormattedBidDescription.value
        }, null, 8, _hoisted_2)
      ]))
    : (_openBlock(), _createBlock(_component_v_textarea, {
        key: 1,
        label: "Comments",
        variant: "outlined",
        color: "accentColor",
        "auto-grow": "",
        rows: "3",
        disabled: __props.isDisabledForm,
        "row-height": "25",
        "hide-details": "",
        shaped: "",
        "model-value": getBidDescription.value,
        "onUpdate:modelValue": setBidDescription
      }, null, 8, ["disabled", "model-value"]))
}
}

})